// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemCfopColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the CFOP (fiscal operation code) column for item subtables.
function itemCfopColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'CFOP',
    dataIndex: ['tax', 'cfop'],
    width: 50,
    align: 'center',
    sorter: (a, b) => {
      const aVal = a?.tax?.cfop || a?.cfop || '';
      const bVal = b?.tax?.cfop || b?.cfop || '';
      return aVal.localeCompare(bVal);
    },
    render: (_, item) => (
      <Text style={{ fontSize }} type="secondary">
        {item?.tax?.cfop || item?.cfop || '—'}
      </Text>
    ),
  };
}

export default itemCfopColumn;
